import {t} from '@eitje/bridge'
import {Colors} from '@eitje/assets'
import utils from '@eitje/utils'
import {flexRender} from '@tanstack/react-table'
import {Layout} from '../../../../layout'
import {Icon} from '../../../../icon'
import {HeaderWithCheckbox} from './checkbox'
import {Dropdown} from './dropdown'
import {HeaderTitle} from './title'
import {ColumnTotal} from './aggregates'
import {GROUPED_CELL_WIDTH, DEFAULT_CELL_WIDTH} from '../../../constants'
import {getPinnedColumns, getTableName, getLeftOffset, isLastPinnedColumn} from '../../../helpers'
import {formatCssVars, makeCnVariants} from '../../../../../helpers'

export const HeaderCell = ({header, rows = [], multiAction, rowDisabled}) => {
	'use no memo'
	//
	// Read taxonomy
	//
	const {column, id: columnName, getContext, index} = header
	const {getIsSorted, columnDef, getIsGrouped, getIsPinned} = column
	const {width: taxWidth, infoIconMessageProps} = columnDef

	//
	// Get states
	//
	const context = getContext()
	const getRowDisabled = rowDisabled
	const tableName = getTableName(context)
	const pinnedColumns = getPinnedColumns(context)
	const isPinned = getIsPinned()
	const lastPinned = isLastPinnedColumn(header.index, context)
	const isGroupedColumn = getIsGrouped()
	const sortDirection = getIsSorted()
	const sortIcon = 'arrow-' + (sortDirection === 'asc' ? 'up' : 'down')
	const withCheckbox = multiAction?.enabled && (isGroupedColumn || pinnedColumns[0] === header.id)
	const width = taxWidth || (isGroupedColumn ? GROUPED_CELL_WIDTH : DEFAULT_CELL_WIDTH)

	//
	// Tooltip
	//
	const tooltip = t(`table.${tableName}.tooltips.${columnName}`, 'untranslated')
	const hideTooltip = tooltip === 'untranslated' && !infoIconMessageProps

	const infoIconMessage = !hideTooltip && {
		...(infoIconMessageProps || {tooltip}),
	}

	const style = isPinned ? formatCssVars({'left-offset': getLeftOffset(index, context)}) : {}
	const classNames = makeCnVariants('advanced-table-header-cell', isPinned && 'pinned', lastPinned && 'last-pinned')

	return (
		<Dropdown
			trigger={
				<Layout className={classNames} width={width} padding="2 4 2 8" height={32} colorSet style={style}>
					<Layout direction="vertical" gap={0} grow height={withCheckbox ? 'unset' : undefined}>
						<HeaderCellContent
							rows={rows}
							header={header}
							infoIconMessage={infoIconMessage}
							withCheckbox={withCheckbox}
							multiAction={multiAction}
							getRowDisabled={getRowDisabled}
						/>
					</Layout>
					{sortDirection ? (
						<Icon name={sortIcon} size="14px" />
					) : (
						<Icon name="chevron-small-down" size="14px" initialFill={Colors.darkGrey} />
					)}
				</Layout>
			}
			header={header}
			width={width}
		/>
	)
}

const HeaderCellContent = ({header, infoIconMessage, withCheckbox, rows, multiAction, getRowDisabled}) => {
	'use no memo'
	const {column, getContext} = header
	const {columnDef} = column
	const {header: headerValue, aggregatesFn, aggregates: aggregatesTax} = columnDef
	const context = getContext()
	const value = utils.funcOrVal(headerValue, context)
	const checkboxCellProps = {...context, aggregates: aggregatesFn, infoIconMessage, getRowDisabled}
	const aggregates = <ColumnTotal header={header} rows={rows} />

	if (withCheckbox)
		return flexRender(
			props => <HeaderWithCheckbox {...context} {...props} aggregates={aggregates} multiAction={multiAction} />,
			checkboxCellProps,
		)

	return (
		<>
			<HeaderTitle value={value} context={context} infoIconMessage={infoIconMessage} />
			{(aggregatesTax || aggregatesFn) && <span className="aggregates"> {aggregates} </span>}
		</>
	)
}
